<template>
<div class="chapter">
<div class="inner_page">
<div class="cap">
<p class="imagea"><a id="page_xvi"><img alt="image" src="images/map.jpg"/></a></p><a id="page_xvi">
<p class="fcaption">Map. The terrain of <i>Performing Trauma in Central Africa</i>.</p>
</a></div><a id="page_xvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_fm01.vue?2019287a